const setElementHeight = (element, height) => {
  const domElement = element;
  domElement.style.height = `${height}px`;
};

export default setElementHeight;
